import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Icon, Input, Modal, Text } from '@pukka/ui-components';

import { BrandsNoData } from '../BrandsNoData';

interface BrandsItemModalProps {
  readonly brandName: string;
  readonly outletName: string;
  readonly itemList: string[];
  readonly open?: boolean;
  readonly onToggleModal?: (open: boolean) => void;
}

function BrandItemsModal({ open, brandName, outletName, itemList, onToggleModal }: BrandsItemModalProps) {
  const { t } = useTranslation('library');
  const tlPrefix = 'brands.assignModal.item';

  const [filter, setFilter] = useState('');

  const filteredList = itemList.filter((item) => item.toLowerCase().includes(filter.toLowerCase()));

  const handleChangeSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFilter(e.target.value);
  };

  const handleClickClose = () => {
    setFilter('');
  };

  return (
    <Modal unwrap open={open} onOpenChange={onToggleModal}>
      <Modal.Content className="!w-[750px]">
        <div className="px-8 py-5 ">
          <div className="flex h-16 items-center justify-between">
            <Modal.Trigger asChild>
              <Button size="s" variant="nude" className="p-0" data-testid="close-btn" onClick={handleClickClose}>
                <Icon icon="close" color="blue" />
              </Button>
            </Modal.Trigger>
          </div>
          <div>
            <Text variant="heading-1" weight="semibold">
              {t(`${tlPrefix}.title`)} {brandName}
            </Text>
            <Text>
              {t(`${tlPrefix}.description`, { count: itemList.length })} {outletName}.
            </Text>
          </div>
        </div>
        <div className="my-4 px-8">
          <Input
            placeholder={t(`${tlPrefix}.searchPlaceholder`)}
            size="l"
            icon="search"
            reverse
            value={filter}
            onChange={handleChangeSearch}
          />

          <div className="mt-4 h-[calc(100vh-400px)] divide-y overflow-y-auto px-4">
            {filteredList.length > 0 &&
              filteredList.map((item, index) => (
                <div key={index} className="flex h-14 items-center px-4">
                  <Text className="truncate">{item}</Text>
                </div>
              ))}
            {filteredList.length === 0 && filter && (
              <div className="mt-4 h-[calc(100vh-400px)] divide-y overflow-y-auto px-4">
                <BrandsNoData
                  title={t('brands.noKeywordFound.title', { keyword: filter })}
                  description={t('brands.noKeywordFound.description')}
                />
              </div>
            )}
          </div>
        </div>
      </Modal.Content>
    </Modal>
  );
}

export { BrandItemsModal };
